import React from 'react';
import './EndFooter.css';

function EndFooter() {
  return (
    <div className='End_Footer'>
        <div>
            <p>
            Copyright © 2020 All rights reserved. STS Pakistan  
            </p>
        </div>
        <div>
        <span>
      7386529
      </span>
        </div>
        <div>
            <p>
            Privacy Policy , Terms & Conditions
            </p>
        </div>
      {/* <p>
      Copyright © 2020 All rights reserved. STS Pakistan
      <span>
      7386529
      </span>
      Privacy Policy , Terms & Conditions
      </p> */}
    </div>
  )
}

export default EndFooter
